import { Star, Quote } from "lucide-react";

export default function Testimonials({ items = [] }) {
  if (!items?.length) return null;
  return (
    <section className="section bg-forest text-bone relative overflow-hidden" data-testid="testimonials-section">
      <div
        className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 200 200\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'n\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.85\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23n)\'/%3E%3C/svg%3E")' }}
      />
      <div className="max-w-7xl mx-auto relative">
        <div className="max-w-3xl mb-12 md:mb-16">
          <div className="text-xs font-bold tracking-[0.2em] uppercase text-terracotta mb-3">Client Stories</div>
          <h2 className="text-3xl md:text-5xl font-display font-bold text-bone tracking-tight mb-4 text-balance">
            What Indianaans say about working with us.
          </h2>
          <p className="text-base md:text-lg text-bone/70 leading-relaxed">
            Stories shared by people we've helped connect with an Indiana attorney. Past results
            do not guarantee future outcomes — every case is different.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {items.map((t, idx) => (
            <div
              key={t.id}
              className="bg-bone/5 border border-bone/10 rounded-2xl p-6 md:p-7 backdrop-blur-sm hover:bg-bone/10 transition-colors"
              data-testid={`testimonial-${idx}`}
            >
              <Quote className="w-7 h-7 text-terracotta mb-4 opacity-80" />
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-terracotta text-terracotta" />
                ))}
              </div>
              <p className="text-bone text-base md:text-lg leading-relaxed mb-5 font-medium">
                "{t.quote}"
              </p>
              <div className="flex items-center justify-between border-t border-bone/10 pt-4">
                <div>
                  <div className="font-display font-bold text-bone">{t.name}</div>
                  <div className="text-xs text-bone/60">{t.location}</div>
                </div>
                {t.accident_type && (
                  <div className="text-[10px] tracking-wider uppercase font-bold text-terracotta px-2 py-1 rounded-full bg-terracotta/10 border border-terracotta/30">
                    {t.accident_type}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
